export default __webpack_public_path__ + "static/media/Green0005.6e194d54.png";